import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNewTranslation } from 'hooks'
import qs from 'query-string'
import { RouteComponentProps, Redirect } from 'react-router-dom'
import Loading from 'components/Loading'
import { createGetRequestsAreLoading, selectCampaign } from 'state'
import { getCampaign, setEditingCampaign } from 'state/campaigns'
import { STATE_KEYS } from 'state/requests'
import { Wrapper } from './Register'
import { RegisterContainer } from './styles'
import Text from 'particles/Text'
import Divider from 'components/Shared/Divider'
import { useCheckSomePermissions } from 'hooks/permissions'
import { CampaignManagement } from 'components/Shared/Permission/enums'
import { selectCMUserUuid } from 'state/profile'
import { setTeamCountryByCampaign } from 'state/filter'

const Register: React.FC<RouteComponentProps> = ({ location }) => {
    const dispatch = useDispatch()
    const [t] = useNewTranslation()
    const { campaign: uuid } = qs.parse(location.search)
    const campaign = useSelector(selectCampaign(uuid && typeof uuid === 'string' ? uuid : ''))
    const isLoading = useSelector(createGetRequestsAreLoading([STATE_KEYS.Campaign]))
    //this is to check if profile is loaded
    const profileUuid = useSelector(selectCMUserUuid)
    const hasCreateNewCampaignPermission = useCheckSomePermissions([
        CampaignManagement.CreateAndEditBriefsForInternal,
        CampaignManagement.CreateAndEditBriefsForExternal,
    ])
    useEffect(() => {
        if (uuid && typeof uuid === 'string') {
            dispatch(
                getCampaign({
                    uuid,
                    onSuccess: campaign => {
                        dispatch(setTeamCountryByCampaign(campaign.uuid))
                    },
                }),
            )
            dispatch(setEditingCampaign({ uuid }))
        }
    }, [dispatch, uuid])

    useEffect(() => {
        return (): void => {
            dispatch(setEditingCampaign({ uuid: null }))
        }
    }, [dispatch])

    if (isLoading) return <Loading />
    if ((profileUuid && !hasCreateNewCampaignPermission && !uuid) || campaign?.in_template_flow)
        return <Redirect to="/404" />

    return (
        <RegisterContainer className="register-form">
            <div className="form-title">
                <Text scale="H4" color="primary">
                    {t('campaignEditor.setUpCampaign.pageTitle')}
                </Text>
                <Divider className="first-divider" />
            </div>
            <Wrapper campaign={campaign} />
        </RegisterContainer>
    )
}

export default Register
